import React from 'react';
import TableItem from '../Table';

interface SensitivitiesTabProps {
  companyData: any;
  entityType?: string;
}

export default function SensitivitiesTab({ companyData, entityType }: SensitivitiesTabProps) {
  // Don't show sensitivities tab for sensitivity entities
  if (entityType === 'sensitivity') {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <div className="text-center text-slate-500 py-8">
          <span className="material-symbols-outlined text-[48px] text-slate-300 mb-4 block">
            tune
          </span>
          <p>You are currently viewing a sensitivity analysis.</p>
          <p className="text-sm mt-2">Sensitivity comparison is available in the base scenario view.</p>
        </div>
      </div>
    );
  }

  if (!companyData?.sensitivities) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <div className="text-center text-slate-500 py-8">
          <span className="material-symbols-outlined text-[48px] text-slate-300 mb-4 block">
            tune
          </span>
          <p>No sensitivities available for this scenario.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8 min-w-0">
      <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
        <h3 className="text-lg font-semibold text-slate-900 mb-4">Sensitivity Analysis</h3>
        <TableItem table={companyData.sensitivities} head_bold={false} bold_column_indexes={[0]} />
      </section>
    </div>
  );
}
